<template>
	<div>
		<el-drawer
			:title="`${data.resourceNo} - 资源详情`"
			:visible.sync="dialogVisible"
			size="45%"
			:close-on-click-modal="false"
			:before-close="handleClose">
			<div class="drawer-content">
				<el-card class="table-card" shadow="always">
					<div slot="header" class="clearfix">
						<span>基本信息</span>
					</div>

					<el-descriptions class="margin-top" :column="2" border>
						<el-descriptions-item label="资源编号">{{ detailData.resourceNo || '--' }}</el-descriptions-item>
						<el-descriptions-item label="资源名称">{{ detailData.resourceName || '--' }}</el-descriptions-item>
						<el-descriptions-item label="资源类型">
							<el-tag :type="ResourceType[detailData.resourceType] || 'default'" size="small">
								{{ $menu.getLabel('ResourceType', detailData.resourceType) }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="所属项目">{{ detailData.communityName || '--' }}</el-descriptions-item>
						<el-descriptions-item label="关联资产">{{ detailData.assetNo || '--' }}</el-descriptions-item>
						<el-descriptions-item label="资产名称">{{ detailData.assetName || '--' }}</el-descriptions-item>
						<el-descriptions-item label="租控状态">
							<el-tag :type="RentalStatus[detailData.currentStatus] || 'default'" size="small">
								{{ $menu.getLabel('RentalStatus', detailData.currentStatus) }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="面积">{{ detailData.area || '--' }}㎡</el-descriptions-item>
						<el-descriptions-item label="租金单价">¥{{ detailData.rentPrice || '--' }}/㎡/月</el-descriptions-item>
						<el-descriptions-item label="月租金">¥{{ detailData.monthlyRent || '--' }}</el-descriptions-item>
					</el-descriptions>
				</el-card>
				<el-card class="table-card" shadow="always">
					<div slot="header" class="clearfix">
						<span>租赁信息</span>
					</div>
					<el-descriptions class="margin-top" :column="2" border>
						<el-descriptions-item label="租客名称" :span="2">{{ detailData.tenantName || '--' }}</el-descriptions-item>
						<el-descriptions-item label="联系电话">{{ detailData.contactPhone || '--' }}</el-descriptions-item>
						<el-descriptions-item label="签约日期">{{ detailData.signDate || '--' }}</el-descriptions-item>
						<el-descriptions-item label="到期日期" :span="2">{{ detailData.expiryDate || '--' }}</el-descriptions-item>
					</el-descriptions>
				</el-card>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import { ResourceType, RentalStatus } from '@/utils/meunType.js';
	import { getResourceById } from '@/api/asset/resourceApi.js';
	export default {
		name: 'ResourceManageDrawer',
		props: {
			dialogVisible: Boolean,
			data: Object,
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.fetchGetResourceById(this.data.id);
					});
				}
			},
		},
		data() {
			return {
				ResourceType,
				RentalStatus,
				activeName: '1',
				detailData: {},
			};
		},
		methods: {
			async fetchGetResourceById(id) {
				console.log(id);
				try {
					const res = await getResourceById(id);
					this.detailData = res;
				} catch (err) {
					console.log(err);
				}
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
		},
	};
</script>

<style scoped lang="scss">
	.drawer-content {
		padding: 10px 24px;
		color: #666;
	}

	.table-card {
		margin-bottom: 10px;
	}
</style>
